import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import Vue2Storage from 'vue2-storage'

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(Vue2Storage, { prefix: 'jr-web_' })

new Vue({
  render: h => h(App),
  router,
  i18n
}).$mount('#app')
